import getConfig from "next/config";
import { getAlgoliaConfigFromBloomreach, getProductTypeFromQueryString, getPlpPromotionSize } from "@grandvisionhq/bloomreach";
import { enrichAlgoliaConfig } from "@grandvisionhq/search";
import { createFeatureConfigs } from "@grandvisionhq/state";
import { EnvironmentUtils } from "@grandvisionhq/utils";
const { algolia } = getConfig().publicRuntimeConfig;
const algoliaBaseConfig = {
  appId: algolia.appId,
  apiKey: algolia.apiKey
};
function getAlgoliaOptions(productType) {
  const featureConfigs = createFeatureConfigs(EnvironmentUtils.getFeatureConfigs());
  if (productType && featureConfigs.algoliaIndexV2EnabledProductTypes?.includes(productType)) {
    return {
      ...algoliaBaseConfig,
      indexName: algolia.newProductIndex.name,
      filters: algolia.newProductIndex.filters,
      sortIndices: algolia.newProductIndex.sortIndices,
      facets: algolia.newProductIndex.facets,
      pageSize: algolia.newProductIndex.pageSize
    };
  }
  return {
    ...algoliaBaseConfig,
    indexName: algolia.productIndex.name,
    filters: algolia.productIndex.filters,
    sortIndices: algolia.productIndex.sortIndices,
    facets: algolia.productIndex.facets,
    pageSize: algolia.productIndex.pageSize
  };
}
function getAlgoliaCrossSellConfig(productType) {
  const { appId, apiKey } = algoliaBaseConfig;
  const { name: indexName, facets } = algolia.crossSellIndex;
  return { appId, apiKey, indexName, facets: facets[productType] || {} };
}
function createAlgoliaConfig(clientQueryString, pageModel, mediaQueryBreakpoint, additionalOptions, productType, refPrefix) {
  const { plpPromotionSize } = getPlpPromotionSize(pageModel, mediaQueryBreakpoint, refPrefix);
  const algoliaOptions = getAlgoliaOptions(productType);
  return {
    clientQueryString,
    options: {
      ...algoliaOptions,
      ...additionalOptions,
      pageSize: algoliaOptions.pageSize - (plpPromotionSize || 0)
    },
    isEnabled: true
  };
}
function buildSearchIndexConfig(clientQueryString, indexes, locale, isMultilingualEnabled, serverUrl) {
  const indices = indexes.map((item) => item.name);
  return {
    ...createAlgoliaConfig(clientQueryString, void 0, void 0, { indices, indexes }),
    // Basic config
    ruleContexts: ["search"],
    locale,
    isMultilingualEnabled,
    serverUrl
  };
}
function buildPlpConfig(clientQueryString, pageModel, breakpoint, locale, isMultilingualEnabled, serverUrl, refPrefix) {
  const cmsAlgoliaConfig = getAlgoliaConfigFromBloomreach(pageModel, refPrefix);
  const { isEnabled, facetingAfterDistinct, presetQueryString, ruleContexts } = cmsAlgoliaConfig;
  const productType = getProductTypeFromQueryString(presetQueryString);
  return {
    ...createAlgoliaConfig(
      clientQueryString,
      pageModel,
      breakpoint,
      void 0,
      productType,
      refPrefix
    ),
    // Override with Bloomreach predefined filters for PLPLs, can contain: ?productType=SUNGLASSES
    presetQueryString,
    // Other overrides from Bloomreach
    ruleContexts,
    facetingAfterDistinct,
    isEnabled,
    // Basic config
    locale,
    isMultilingualEnabled,
    serverUrl
  };
}
async function getAlgoliaConfig({
  serverUrl,
  clientQueryString,
  pageModel,
  breakpoint,
  locale,
  ruleContexts,
  indexes = [],
  isMultilingualEnabled = false,
  router,
  refPrefix
}) {
  const hasSearchIndexes = indexes.length > 0 && ruleContexts;
  const config = hasSearchIndexes ? buildSearchIndexConfig(clientQueryString, indexes, locale, isMultilingualEnabled, serverUrl) : buildPlpConfig(
    clientQueryString,
    pageModel,
    breakpoint,
    locale,
    isMultilingualEnabled,
    serverUrl,
    refPrefix
  );
  return enrichAlgoliaConfig(config, router);
}
export {
  getAlgoliaCrossSellConfig as a,
  getAlgoliaConfig as g
};
//# sourceMappingURL=algolia.js.map
